import axiosClient from "@/utils/axios-client";
import { ShippingInfoResponse } from "@/shared/api/shipping-infos/types";
import { shippingInfosUrl } from "@/shared/api/shipping-infos/url";

export const shippingInfosQueryApi = {
  // 바이어의 배송지 목록 조회 — 목록 조회는 company_type과 무관하게 /buyers/{buyer_id} 고정이다.
  getShippingInfos: async (buyerId: number) => {
    const { data } = await axiosClient.get<ShippingInfoResponse[]>(
      shippingInfosUrl.byBuyer(buyerId)
    );
    return data;
  },
};
